module.exports = __webpack_public_path__ + "img/l.fe7dac2f.webp";